import { render, staticRenderFns } from "./teamDialog.vue?vue&type=template&id=0abb3b96&scoped=true&"
import script from "./teamDialog.vue?vue&type=script&lang=js&"
export * from "./teamDialog.vue?vue&type=script&lang=js&"
import style0 from "./teamDialog.vue?vue&type=style&index=0&id=0abb3b96&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0abb3b96",
  null
  
)

export default component.exports